import {
  DigitalProduct,
  DigitalVariant,
  PrintProduct,
  PrintVariant,
  Product,
  ProductAvailability,
  Variant,
} from "../../../../common/api/decimal/methods/product.ts";

export function isPrintProduct(product: Product): product is PrintProduct {
  return product.variants.some((variant) => variant.source === "Akademos");
}

export function isDigitalProduct(product: Product): product is DigitalProduct {
  return !isPrintProduct(product);
}

export function isPrintVariant(variant: Variant): variant is PrintVariant {
  return variant.source === "Akademos";
}

export function isDigitalVariant(variant: Variant): variant is DigitalVariant {
  return !isPrintVariant(variant);
}

export function isPackage(product: Product) {
  return isDigitalProduct(product) && product.kind === "Package";
}

export function isGiftCardProduct(product: Product) {
  return isGiftCardVariant(product.variants[0]);
}

export function isGiftCardVariant(variant: Variant) {
  return variant.taxCategory === "Gift Cards";
}

export const printReturnDays = 30;

export function isTemporarilyOutOfStock(
  variant: Pick<Variant, "productAvailability">
) {
  if (variant.productAvailability) {
    const tempOutOfStockValues: ProductAvailability[] = [
      "Temporarily unavailable",
      "Awaiting stock",
    ];
    return tempOutOfStockValues.includes(variant.productAvailability);
  }
  return false;
}

export function isOutOfStock(variant: Variant) {
  return variant?.productAvailability === "Out of stock";
}

export function isMarketplace(variant: Variant) {
  return variant?.condition === "marketplace";
}

/**
 * This can return an out of stock variant that should not appear visually
 * checked but is checked under the hood in order to show price/policy information
 * elsewhere on the page.
 */
export function getDefaultCheckedVariantId(product: Product) {
  return getDefaultCheckedVariant(product).id;
}

export function getDefaultCheckedVariant(product: Product) {
  if (!isPrintProduct(product)) {
    return product.variants[0];
  }
  const variantWithStock = product.variants.find(
    (variant) => !isOutOfStock(variant)
  );
  return variantWithStock ? variantWithStock : product.variants[0];
}

export const virtualStoreReturnPolicyUrl =
  "https://onlinebookstoresupport.vitalsource.com/hc/en-us/articles/28515881387287-Returns-Policy";
